// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"19736":"64b0b51fcefb1ae5","53217":"84b15c317e509b59","53319":"50e1d4af1f8f7c64","56545":"9bffacbe60a21772","88941":"2df41e277d8c6381"}[chunkId] + ".css";
};